import instance from '../api';

export const getUserList = params => { return instance.get('/user/list', {params: params})};

export const listUsername = () => { return instance.get('/user/listUsername') };

export const info = params => { return instance.get('/user/info', {params: params})};

export const removeUser = params => { return instance.get('/user/delete', { params: params }); };

export const editUser = params => { return instance.post('/user/update', params ); };

export const addUser = params => { return instance.post('/user/add',  params ); };

export const loginVerify = params => { return instance.get('/user/loginVerify', { params:params })};

export const modifyPassword = params => { return instance.get('/user/modify', { params:params })};

// 仓库管理界面接口

export const getDepotList = params => {return instance.get('/depot/list', {params: params})};

export const getDepotInfo = params => {return instance.get('/depot/info', {params: params})};

export const addDepot = params => {return instance.post('/depot/add', params )};

export const editDepot = params => {return instance.post('/depot/modify', params)};

export const removeDepot = params => {return instance.get('/depot/delete', {params: params})};


// 设备管理界面接口
export const getDeviceInfo = () => { return instance.get('/device/info')};

export const getDeviceList = params => {return instance.get('/device/list', { params: params})};

export const removeDevice = params => {return instance.get('/device/delete', { params: params})};

export const addDevice = params => {return instance.post('/device/add', params )};

export const modifyDevice = params => {return instance.post('/device/modify', params )};

// 功能管理界面接口
export const getFeatureInfo = () => { return instance.get('/feature/info')};

export const getFeatureList = params => {return instance.get('/feature/list', { params: params})};

export const removeFeature = params => {return instance.get('/feature/delete', { params: params})};

export const addFeature = params => {return instance.post('/feature/add', params )};

export const modifyFeature = params => {return instance.post('/feature/modify', params )};

// 角色管理界面接口
export const getRoleList = params => {return instance.get('/role/list', {params:params} )};

export const removeRole = params => {return instance.get('/role/delete', { params: params})};

export const addRole = params => {return instance.post('/role/add', params )};

export const modifyRole = params => {return instance.post('/role/update', params )};

// 订单管理界面接口

export const getRecordList = params => {return instance.get('/record/list', {params: params})};

export const getRecordInfo = params => {return instance.get('/record/info', {params: params})};

// 权限管理界面接口

export const getPermissionList = () => {return instance.get('/permission/list')};

export const removePermission = params => {return instance.get('/permission/delete', { params: params })};

export const addPermission = params => {return instance.post('/permission/add', params )};

export const modifyPermission = params => {return instance.post('/permission/update', params )};

export const verifyMobile = params => {return instance.get('/user/verifyMobile', { params: params })};

export const getCode = params => {return instance.get('/user/sendCode', { params: params })};

export const mobileLogin = params => {return instance.get('/user/mobileLogin', { params: params })};

export const getContractInfo = params => { return instance.get('/contract/info',{ params: params })};

export const getContractList = params => { return instance.get('/contract/list', { params: params })};

export const addContract = params => { return instance.post('/contract/add', params )};

export const assignContract = params => { return instance.post('/contract/assign',params )};

export const editContract = params => { return instance.post('/contract/modify', params )};

export const removeContract = params => { return instance.get('/contract/delete', { params: params })};


// WEBPACK FOOTER //
// ./src/api/api.js